import api from "./api";

export const HelpdeskRecipesAPI = {
  list: () => api("/helpdesk/admin/recipes"),

  availableForTicket: (ticketId) => api(`/tickets/${ticketId}/recipes`),

  runForTicket: (ticketId, recipeId) =>
    api(`/tickets/${ticketId}/recipes/${recipeId}/run`, { method: "POST" }),

  get: (id) => api(`/helpdesk/admin/recipes/${id}`),

  create: (data) =>
    api("/helpdesk/admin/recipes", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id, data) =>
    api(`/helpdesk/admin/recipes/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    }),

  enable: (id) =>
    api(`/helpdesk/admin/recipes/${id}/enable`, {
      method: "POST",
    }),

  disable: (id) =>
    api(`/helpdesk/admin/recipes/${id}/disable`, {
      method: "POST",
    }),

  delete: (id) =>
    api(`/helpdesk/admin/recipes/${id}`, {
      method: "DELETE",
    }),

  listNotifications: () => api("/helpdesk/admin/notifications"),

  listSchoolOptions: () =>
    api("/helpdesk/admin/rules/options/schools"),

  listDepartmentOptions: () =>
    api("/helpdesk/admin/rules/options/departments"),

  listRoleOptions: () =>
    api("/helpdesk/admin/recipes/options/roles"),

  listStatusOptions: () =>
    api("/helpdesk/admin/rules/options/statuses"),

  listCategoryOptions: () =>
    api("/helpdesk/admin/rules/options/categories"),

  listSubcategoryOptions: () =>
    api("/helpdesk/admin/rules/options/subcategories"),

  listUsers: () =>
    api("/helpdesk/admin/users"),
};